module.exports = __webpack_public_path__ + "asset/image/signal-e9c1.svg";